import tB from "../data/timeBasis.json";
import setDefaultValues from "./setDefaultValues";

export default function getTimeInfo(c) {
  // TODO 1468, felhantering vid felaktiga funktionsanrop
  // - ingen config
  // - ej fullständig konfig
  // - ej förväntade värden på inputs

  // Copy objects to avoid mutation
  const timeBasis = JSON.parse(JSON.stringify(tB));
  const configuration = JSON.parse(JSON.stringify(c));

  // Update confifguration with default values for dimensions
  // where user input has not been set at the moment
  setDefaultValues(configuration);

  // If construction work is done by customer (without support), apply time factor
  const foundationFactor =
    configuration.constructionSupport === "needs_support" ? 1 : 1.5;
  const constructionFactor =
    configuration.constructionSupport === "needs_support" ? 1 : 1.5;

  // Round downwards to nearest 5
  const roundMethod = exactTime => {
    if (typeof exactTime === "number") {
      return Math.floor(exactTime / 5) * 5;
    }

    return null;
  };

  const foundationTime =
    configuration.foundation === "already_completed"
      ? null
      : roundMethod(
          foundationFactor *
            timeBasis[configuration.size].foundation[configuration.foundation]
        );

  const constructionTime = roundMethod(
    constructionFactor * timeBasis[configuration.size].construction
  );

  // Adding some meta info (nice to have)
  const meta = {
    factorsUsed: {
      foundationFactor,
      constructionFactor
    },
    constructionSupport: configuration.constructionSupport,
    isFoundationAlreadyCompleted:
      configuration.foundation === "already_completed"
  };

  // Setup timeInfo
  const timeInfo = {
    foundationTime,
    constructionTime,
    meta
  };

  return timeInfo;

  /* Dummy example of returned timeInfo object
  {
    foundationTime: 70,
    constructionTime: 180,
    meta: {
      factorUsed: 2,
      constructionSupport: "none",
      isFoundationAlreadyCompleted: false
    }
  }
  */
}
